import { createUseStyles } from 'react-jss';

const fontFamily = 'National2,"Helvetica Neue",Helvetica,Arial,sans-serif';

type classNames = 'container' | 'text' | 'link' | 'logo' | 'imageLink';
type themeProps = {
  surveyTheme: any;
  logoColor: string;
};
type themeShape = Record<string, any>;

const useStyles = createUseStyles<classNames, themeProps, themeShape>(wrenchTheme => ({
  container: {
    margin: '0 auto',
    padding: 0,
  },
  text: {
    color: ({ surveyTheme }) => surveyTheme.questionColor, // Should this be from survey theme?
    padding: 0,
    margin: '0',
    width: '100%',
    textAlign: 'center',
    lineHeight: '15px',
    fontFamily, // Should this be wds?
    // fontFamily: wrenchTheme.fontFamily.base,
    fontSize: '12px',
    display: 'inline-block',
  },
  link: {
    color: ({ surveyTheme }) => surveyTheme.questionColor,
    textDecoration: 'underline',
    fontFamily, // Should this be wds?
    // fontFamily: wrenchTheme.fontFamily.base,
    lineHeight: '15px',
    fontSize: '12px',
    display: 'inline-block',
  },
  logo: {
    width: '100%',
    color: ({ logoColor }) => logoColor,
    fill: ({ logoColor }) => logoColor,
  },
  imageLink: {
    width: '157px',
    margin: '2px auto 5px',
    display: 'block',
  },
}));

export default useStyles;
